"use strict";
// Ported from https://github.com/aws/amazon-ssm-agent/blob/7ca3c5bc019da3801023c54ef3514d5cdceac9f0/agent/session/contracts/model.go
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadType = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    // InteractiveShellMessage message type for interactive shell.
    MessageType["InteractiveShellMessage"] = "interactive_shell";
    // TaskReplyMessage represents message type for task reply
    MessageType["TaskReplyMessage"] = "agent_task_reply";
    // TaskCompleteMessage represents message type for task complete
    MessageType["TaskCompleteMessage"] = "agent_task_complete";
    // AcknowledgeMessage represents message type for acknowledge
    MessageType["AcknowledgeMessage"] = "acknowledge";
    // AgentSessionState represents status of session
    MessageType["AgentSessionState"] = "agent_session_state";
    // ChannelClosedMessage represents message type for ChannelClosed
    MessageType["ChannelClosedMessage"] = "channel_closed";
    // OutputStreamDataMessage represents message type for outgoing stream data
    MessageType["OutputStreamDataMessage"] = "output_stream_data";
    // InputStreamDataMessage represents message type for incoming stream data
    MessageType["InputStreamDataMessage"] = "input_stream_data";
    // PausePublicationMessage message type for pause sending data packages.
    MessageType["PausePublicationMessage"] = "pause_publication";
    // StartPublicationMessage message type for start sending data packages.
    MessageType["StartPublicationMessage"] = "start_publication";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var PayloadType;
(function (PayloadType) {
    PayloadType[PayloadType["Output"] = 1] = "Output";
    PayloadType[PayloadType["Error"] = 2] = "Error";
    PayloadType[PayloadType["Size"] = 3] = "Size";
    PayloadType[PayloadType["Parameter"] = 4] = "Parameter";
    PayloadType[PayloadType["HandshakeRequest"] = 5] = "HandshakeRequest";
    PayloadType[PayloadType["HandshakeResponse"] = 6] = "HandshakeResponse";
    PayloadType[PayloadType["HandshakeComplete"] = 7] = "HandshakeComplete";
    PayloadType[PayloadType["EncChallengeRequest"] = 8] = "EncChallengeRequest";
    PayloadType[PayloadType["EncChallengeResponse"] = 9] = "EncChallengeResponse";
    PayloadType[PayloadType["Flag"] = 10] = "Flag";
})(PayloadType = exports.PayloadType || (exports.PayloadType = {}));
